// Module
var code = `<app-moo-header></app-moo-header>
<div class="HOA-content-main">
  <div class="HOA-ui-view-wrapper"> <!-- this scroll div needs to wrap the ui-views so it controls both nested views -->
    <div class="Container u-height-100p"> <!-- Container, which limits max-width, needs to be inside scroll div so the scrollbars are far left and right-->
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<!--<moo-footer></moo-footer>-->
<app-push-pop-footer></app-push-pop-footer>
`;
// Exports
module.exports = code;